import { Directive } from '@angular/core';

@Directive({
  selector: '[entityListHeader]',
})
export class EntityListHeaderDirective {}
